import { render, staticRenderFns } from "./LgsReferralGuideCreate.vue?vue&type=template&id=297db80a"
import script from "./LgsReferralGuideCreate.vue?vue&type=script&lang=js"
export * from "./LgsReferralGuideCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports